import React, { ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export default function ExpandBox(props: {
    show: boolean;
    children: ReactNode;
    header: ReactNode;
}) {
    return (
        <>
            {props.header}
            <AnimatePresence initial={false}>
                {props.show && (
                    <motion.div
                        className={'overflow-hidden'}
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        transition={{
                            duration: 0.2,
                        }}
                        variants={{
                            open: {
                                height: 'auto',
                            },
                            collapsed: {
                                height: 0,
                            },
                        }}>
                        {props.children}
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
